import { DEVICES } from '@constants/global'
import { COLORS } from '@styles/colors'
import styled from 'styled-components'

export const SuburbProfileSearchForm = styled.div`
  width: 100%;
  max-width: 830px;
  padding: 16px 24px;
  background-color: ${COLORS.nature[95]};
  display: flex;
  align-items: center;
  position: relative;
  gap: 12px;

  > div {
    width: 100%;
  }


  button {
    @media ${DEVICES.mobile} {
      display: none;
    }
  }

  > svg {
    color: ${COLORS.secondary};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 48px;
    z-index: 10;
  }

  .bp-autocomplete {
    width: 100%;

    &__control {
      padding: 4px 16px 4px 52px;
      border: 1px solid ${COLORS.nature[80]};
      border-radius: 4px;
      width: 100%;
      font-size: 16px;
      color: ${COLORS.secondary};
      box-shadow: none;

      &::placeholder {
        color: ${COLORS.secondary};
      }
    }

    &__option {
      color: ${COLORS.secondary};
    }

    &__input-container {
      font-size: 16px;
      color: ${COLORS.secondary};
    }

    &__single-value,
    &__placeholder,
    &__input {
      color: ${COLORS.secondary};
    }
  }

  @media ${DEVICES.mobile} {
    width: calc(100% + 30px);

    > svg {
      left: 40px;
    }

    .bp-autocomplete {
      width: 100%;

      &__control {
        padding: 4px 16px 4px 42px;
      }

      &__placeholder {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
`
